// extracted by mini-css-extract-plugin
module.exports = {"tags":"tags_tags__8Mcze","tag":"tags_tag__W_tHh"};